exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress {\n    width: 100%;\n    height: 34px;\n    overflow: hidden;\n    margin-bottom: 0;\n}", ""]);

// exports
